<template>

    <li class="mt-4 border-bottom" v-if="comment != null">
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
                <!--                                    <a class="pe-3" href="/portfolio-detail-one"><img-->
                <!--                                    src="/static/media/03.ba5f8794c055cc1488b5.jpg"-->
                <!--                                    class="img-fluid avatar avatar-md-sm rounded-circle shadow" alt="img"></a>-->
                <div class="commentor-detail"><h6 class="mb-1">
                    <a class="text-dark media-heading"  href="#">{{ comment.user?.name }}</a>
                </h6><small class="text-muted">{{ comment.created_at }}</small>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="text-muted fst-italic p-3 bg-light rounded mb-1" v-html="comment.comment"></div>

            <!--                                <div class="accordion" id="accordionPanelsStayOpenExample">-->
            <div class="">
                <div class="accordion-item">
                    <div class="d-flex justify-content-end mb-1">
                        <a class="text-muted mx-2 py-1"
                           data-bs-toggle="collapse" :data-bs-target="'#panelsStayOpen-collapse' + comment.id "
                           aria-expanded="true" :aria-controls="'panelsStayOpen-collapse' + comment.id "
                           :href=" 'Reply' + comment.id " @click="scrollToSection('Reply' + comment.id)">
                            <i class="mdi mdi-reply"></i>Reply</a>
                        <report :discussion_id="comment.id"></report>

                        <RatingButtons :id="comment.id"
                                       :difference="comment?.likes?.difference"
                                       type="discussion"
                                       :icons_type="'hands'"
                                       :user_like="comment?.user_like"
                                       @update:user_like="comment.user_like = $event"
                         />
                    </div>



                    <ul class="list-unstyled ps-4 sub-comment mb-3 ms-2">
                        <li class="mb-4" v-for="discussion in comment.discussions">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center">
                                    <!--                                                    <a class="pe-3"-->
                                    <!--                                                                                          href="/portfolio-detail-one"><img-->
                                    <!--                                                    src="/static/media/04.35463172278c4051b5f4.jpg"-->
                                    <!--                                                    class="img-fluid avatar avatar-md-sm rounded-circle shadow"-->
                                    <!--                                                    alt="comment"></a>-->

                                    <div class="commentor-detail"><h6 class="mb-1">
                                        <a class="text-dark media-heading"  href="#">{{ discussion.user?.name }}</a>
                                    </h6><small class="text-muted">{{ discussion.created_at }}</small>
                                    </div>


                                </div>
                            </div>
                            <div class="mt-3">

                                <div class="text-muted fst-italic p-3 bg-light rounded" v-html="discussion.comment"></div>

                            </div>
                            <div class="d-flex justify-content-end mb-1">

                                <RatingButtons :id="discussion.id"
                                               :difference="discussion?.likes?.difference"
                                               type="discussion"
                                               :icons_type="'hands'"
                                               :user_like="discussion?.user_like"
                                               @update:user_like="discussion.user_like = $event"
                                />

                                <report :discussion_id="discussion.id"></report>
                            </div>
                        </li>
                    </ul>

                    <div :id="'panelsStayOpen-collapse' + comment.id "
                         class="accordion-collapse collapse "
                         :aria-labelledby="'panelsStayOpen-heading'+ comment.id ">
                        <div class="accordion-body">
                            <form @submit.prevent="create" :id=" 'Reply' + comment.id " >
                                <div class=" rounded border-0 card">
                                    <div class="p-3 px-0">
                                        <!--                                                            <h5 class="card-title mb-1">Leave A Discuss :</h5>-->
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label class="form-label form-label">Your Comment</label>
                                                    <div class="form-icon position-relative"><i>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                             stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                             stroke-linejoin="round"
                                                             class="feather feather-message-circle fea icon-sm icons">
                                                            <g>
                                                                <path
                                                                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                                                            </g>
                                                        </svg>
                                                    </i></div>

                                                    <textarea  class="form-control ps-5" rows="2" v-model="item.comment"
                                                               placeholder="Your Comment"
                                                               :class="{ 'is-invalid' : isInvalid('comment')}"  required></textarea>

                                                    <div class="invalid-feedback" v-if="isInvalid('comment')">
                                                        {{ isInvalid('comment') }}
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="send d-grid w-25">
                                                    <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>

</template>

<script>
import {useToast} from "vue-toastification";
import axios from "axios";
import RatingButtons from "../share/RatingButtons.vue";
import Report from "../discussion_report/report.vue";

const toast = useToast();

export default {
    components: {Report, RatingButtons},
    props: {
        comment: {
            required: true
        }
    },
    data() {
        return {
            // items: [],
            item: {},
            // validationErrors: null,
            // error_message: null,
        }
    },
    created() {
        // this.getResults();
    },
    methods: {
        scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        },
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {

            const id = toast.info('creating ...', {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });
            formData.append('discussion_id', this.comment.id);
            formData.append('subscribe_id', this.$route?.params?.subscribe_id);

            axios.post('question_discussions',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                // add response.data.data to comment.discussions in end
                this.comment?.discussions?.push(response.data.data);

                this.item = {};

            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    that.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });

        }
    }
};
</script>

<style scoped>
.btn {
    cursor: pointer;
}
</style>
